import { Link } from 'react-router-dom';
import '../styles/Containers.css';

function Banner1(props) {
  const { title, desc, linkTo, bclass } = props;
  return (
    <div>
      <Link to={linkTo} className={bclass}>
        <div>
          <p className="heading-3 purple-1">{title}</p>
          <p className="caption-1 grey-2">{desc}</p>
        </div>
      </Link>
    </div>
  );
}
export default Banner1;
